const initialState = {

    allCustomer: [],
    error: null,
    get_location_details: [],
    change_user_location: null
  };

  const createCustomerReducer = (state = initialState, action) => {
    switch (action.type) {


      case 'SAVE_CREATE_CUSTOMER_SUCCESS':
        return { ...state, allCustomer: action.payload, error: null };
      case 'SEARCH_TASK_SUCCESS':
            return { ...state, allTask: action.payload, error: null };

      case 'GET_LOCATION_HEADER_SUCCESS':
        return { ...state, get_location_details: action.payload, error: null };

        case 'SWITCH_USER_LOCATION_SUCCESS':
        return { ...state, change_user_location: action.payload, error: null };

      case 'SAVE_CREATE_CUSTOMER_FAILURE':
      case 'UPDATE_TASK_FAILURE':

        return { ...state, error: action.payload };
      default:
        return state;
    }
  };

  export default createCustomerReducer;
